import {graphql, compose} from 'react-apollo';
import React from 'react';
import gql from 'graphql-tag';

import { Centered1000 } from '../arkulpa-fec/components/Container';
import {registerUserQuery} from '../qql-shared/queries';
import UserForm from '../components/UserForm';

const registerMutation = gql`
  mutation registerUser(
    $email: String!
    $password: String!
    $firstName: String!
    $lastName: String!
    $birthdayStr: String!
    $phone: String!
    $street: String!
    $zipCode: String!
    $city: String!
    $bankName: String
    $iban: String
    $bic: String
    $svNumber: String!
    $nationality: String!
    $maritalStatus: String
    $passportNumber: String!
    $passportValidFromStr: String!
    $passportValidUntilStr: String!
    $passportAgency: String!
    $education: String!
    $job: String!
    $workExperience: String
    $additionalInfo: String
    $licenses: [String]
    $languages: [String]
  ) {
    registerUser(
      email: $email
      password: $password
      firstName: $firstName
      lastName: $lastName
      birthdayStr: $birthdayStr
      phone: $phone
      street: $street
      zipCode: $zipCode
      city: $city
      bankName: $bankName
      iban: $iban
      bic: $bic
      svNumber: $svNumber
      nationality: $nationality
      maritalStatus: $maritalStatus
      passportNumber: $passportNumber
      passportValidFromStr: $passportValidFromStr
      passportValidUntilStr: $passportValidUntilStr
      passportAgency: $passportAgency
      education: $education
      job: $job
      workExperience: $workExperience
      additionalInfo: $additionalInfo
      licenses: $licenses
      languages: $languages
    ) {
      _id
      token
    }
  }
`;

const registerMutationConfig = {
  props: ({mutate}) => ({
    save: variables => {
      return mutate({
        variables,
        update: (_, {data: {register}}) => {
          console.log('register done ', register);
        }
      });
    }
  })
};

export default compose(graphql(registerMutation, registerMutationConfig), graphql(registerUserQuery))(props =>
  <Centered1000>
    <UserForm {...props} register={true} />
  </Centered1000>
);



// WEBPACK FOOTER //
// ./src/containers/RegisterPage.js